export default "__VITE_ASSET__C8j_FokN__"